module.exports = __webpack_public_path__ + "img/section1.64056295.png";